import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo/pms-logo.png";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-dark text-white">

      {/* Main footer body */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">

        {/* Brand col */}
        <div>
          <img src={logo} alt="PMS Packages" className="h-10 w-auto mb-4 opacity-90" />
          <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
            Full-service corrugated packaging manufacturer delivering durable,
            cost-effective, and custom solutions across industries.
          </p>
        </div>

        {/* Quick links */}
        <div>
          <h5 className="text-xs uppercase tracking-widest text-gray-500 font-semibold mb-4">Quick Links</h5>
          <ul className="space-y-2.5 text-sm text-gray-400">
            {[
              { label: "About", id: "about" },
              { label: "Products", id: "products" },
              { label: "Services", id: "services" },
              { label: "Process", id: "process" },
            ].map(({ label, id }) => (
              <li key={id}>
                <button
                  onClick={() => handleNav(id)}
                  className="hover:text-white transition-colors duration-150"
                >
                  {label}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => navigate("/contact")}
                className="hover:text-white transition-colors duration-150"
              >
                Contact Us
              </button>
            </li>
          </ul>
        </div>

        {/* Contact info */}
        <div>
          <h5 className="text-xs uppercase tracking-widest text-gray-500 font-semibold mb-4">Get In Touch</h5>
          <ul className="space-y-3 text-sm text-gray-400">

            <li className="flex items-start gap-2.5">
              <svg className="w-4 h-4 mt-0.5 text-brand-green flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>H-160-Z-24-26 SITE, PHASE II, SUPERHIGHWAY, KARACHI, PAKISTAN</span>
            </li>

            {/* Google Maps embed */}
            <li>
              <a
                href="https://maps.app.goo.gl/hHZxbC77LeSN1gNW7"
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-xl overflow-hidden border border-white/10 hover:border-brand-green/50 transition-colors duration-200 group"
              >
                <div className="relative">
                  <iframe
                    title="PMS Packages Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28927.915332975954!2d67.09085164244269!3d25.0004755763852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb347eb1bcbe683%3A0x2e4f319951e7b7e8!2sPms%20packages!5e0!3m2!1sen!2s!4v1772983770192!5m2!1sen!2s"
                    width="100%"
                    height="150"
                    style={{ border: 0, display: "block", filter: "grayscale(1) brightness(0.7) contrast(1.1)" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                  {/* Hover overlay */}
                  <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/30 transition-all duration-200 pointer-events-none">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-brand-green text-white text-[10px] uppercase tracking-widest font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5">
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      Open in Maps
                    </span>
                  </div>
                </div>
              </a>
            </li>

            <li className="flex items-center gap-2.5">
              <svg className="w-4 h-4 text-brand-green flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <a href="tel:+923009246032" className="hover:text-white transition-colors duration-150">+92 300 924 6032</a>
            </li>

            <li className="flex items-start gap-2.5">
  <svg className="w-4 h-4 mt-0.5 text-brand-green flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
  <div className="flex flex-col gap-1">
    <a href="mailto:info@pmspackages.com" className="hover:text-white transition-colors duration-150">info@pmspackages.com</a>
    <a href="mailto:hello@pmspackages.com" className="hover:text-white transition-colors duration-150">hello@pmspackages.com</a>
  </div>
</li>

            <li className="mt-2">
              <button
                onClick={() => navigate("/contact")}
                className="inline-block px-5 py-2.5 bg-brand-green text-white text-xs uppercase tracking-widest font-semibold rounded-lg hover:bg-brand-blue transition-colors duration-200"
              >
                Contact Us
              </button>
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} PMS Packages. All rights reserved.</span>
          <span className="text-gray-600">Engineered for performance. Built to last.</span>
        </div>
      </div>

    </footer>
  );
}